"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "ICO-CIRCULAR-NUBICO",
    transform: "translate(-8108 707)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "Enmascarar_grupo_2729",
      "data-name": "Enmascarar grupo 2729",
      transform: "translate(40)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        id: "Grupo_8113",
        "data-name": "Grupo 8113",
        transform: "translate(204.658 -76.245)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          id: "Grupo_8111",
          "data-name": "Grupo 8111",
          transform: "translate(7866.5 -613.026)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            id: "Grupo_8110",
            "data-name": "Grupo 8110",
            transform: "translate(0 0)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              id: "Grupo_8109",
              "data-name": "Grupo 8109",
              transform: "translate(0 0)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                id: "Trazado_8288",
                "data-name": "Trazado 8288",
                d: "M-1.53-167.939a6.428,6.428,0,0,1,3.2-7.016,5.384,5.384,0,0,1,2.056-.638c.24-.02.338-.1.374-.361a5.35,5.35,0,0,1,2.194-3.74,5.1,5.1,0,0,1,7.2,1.234c.107.152.21.308.356.522a6.315,6.315,0,0,1,1.323-2.6,6.52,6.52,0,0,1,8.038-1.663,6.264,6.264,0,0,1,3.231,4.9c.026.2.049.305.3.331a6.854,6.854,0,0,1,5.958,5.447,7.7,7.7,0,0,1,.018,3.007,6.992,6.992,0,0,1-7,5.588c-7.033-.067-14.068-.021-21.1-.018a5.717,5.717,0,0,1-1.382-.131,6.188,6.188,0,0,1-4.767-4.857",
                transform: "translate(1.667 182.951)",
                fill: "#fff"
              })
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          id: "Grupo_8112",
          "data-name": "Grupo 8112",
          transform: "translate(7867.167 -625.69)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            id: "Trazado_8290",
            "data-name": "Trazado 8290",
            d: "M87.084,3.363A1.924,1.924,0,0,1,88.447,5.08a1.91,1.91,0,0,1-1.741,2.158c-.284.024-.575.008-.866.008-.095,0-.236.039-.228-.134.008-.134.126-.11.213-.11h.709a1.657,1.657,0,0,0,1.686-1.7A1.667,1.667,0,0,0,86.58,3.552c-.26-.008-.528,0-.788-.008-.087,0-.2.008-.2-.126s.118-.118.213-.118h.473a1.427,1.427,0,0,0,1.4-1.41A1.373,1.373,0,0,0,86.4.386C85.525.339,84.643.37,83.768.354c-.268-.008-.252.158-.252.331V4.93a2.056,2.056,0,0,1-1.7,2.253,3,3,0,0,1-3.229-.922,1.243,1.243,0,0,1-.268-.725C78.3,3.8,78.3,2.079,78.294.346c0-.1-.016-.244.134-.228.181.016.118.181.118.284.008,1.465,0,2.938,0,4.4a1.975,1.975,0,0,0,2.071,2.26,2.95,2.95,0,0,0,1.6-.291,1.692,1.692,0,0,0,1.048-1.646c-.008-1.544.008-3.1-.008-4.639,0-.315.087-.4.394-.394.89.024,1.78,0,2.678.032a1.534,1.534,0,0,1,1.5,1.126,1.761,1.761,0,0,1-.543,1.953A2.127,2.127,0,0,0,87.084,3.363Z",
            transform: "translate(-72.124 -0.088)",
            fill: "#fff"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            id: "Trazado_8291",
            "data-name": "Trazado 8291",
            d: "M232.675,7.826a3.355,3.355,0,0,0,2.961-1.749c.063-.1.095-.3.268-.213.189.095.008.228-.039.323a3.666,3.666,0,0,1-3.883,1.843,3.607,3.607,0,0,1-2.9-3.025,3.555,3.555,0,0,1,2.45-3.875,3.656,3.656,0,0,1,4.3,1.662,1.217,1.217,0,0,1,.095.173c.024.063.1.15-.016.2a.143.143,0,0,1-.2-.071c-.039-.071-.079-.134-.118-.2a3.387,3.387,0,0,0-6.309,1.528A3.366,3.366,0,0,0,232.675,7.826Z",
            transform: "translate(-211.004 -0.88)",
            fill: "#fff"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            id: "Trazado_8292",
            "data-name": "Trazado 8292",
            d: "M.235.668v2.78c0,.095.032.236-.118.244-.189.008-.15-.15-.15-.26C-.041,2.377-.041,1.314-.041.251c0-.087-.032-.2.095-.228.1-.032.165.055.221.126.315.441.63.874.937,1.307,1.2,1.67,2.4,3.332,3.6,5,.032.039.063.079.165.2V.455c0-.1,0-.213.008-.315.008-.071.047-.126.126-.118s.1.063.11.134.008.158.008.236V6.8c0,.118.079.291-.087.347-.181.063-.236-.118-.315-.236Q2.665,3.9.495.9C.432.818.408.7.235.668Z",
            transform: "translate(0.044 -0.015)",
            fill: "#fff"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            id: "Trazado_8293",
            "data-name": "Trazado 8293",
            d: "M217.726,4.265V1c0-.11-.071-.307.134-.3.165,0,.118.181.118.284V7.558c0,.11.039.284-.126.284-.2,0-.126-.2-.126-.307Z",
            transform: "translate(-200.56 -0.643)",
            fill: "#fff"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            id: "Trazado_8295",
            "data-name": "Trazado 8295",
            d: "M3.789,0a3.735,3.735,0,0,1,3.8,3.655A3.794,3.794,0,0,1,0,3.67,3.767,3.767,0,0,1,3.789,0ZM3.781.26A3.5,3.5,0,0,0,.26,3.686,3.537,3.537,0,0,0,3.812,7.1a3.472,3.472,0,0,0,3.5-3.489A3.438,3.438,0,0,0,3.781.26Z",
            transform: "translate(25.441 0)",
            fill: "#fff"
          })]
        })]
      })
    })
  })
});

var Nubico = function Nubico(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Nubico-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '3 3.9 34.9 34.9';
  }

  if (!mainDimension) {
    mainDimension = 'both';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Nubico;
exports["default"] = _default;

//# sourceMappingURL=index.js.map